import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SearchTip.css';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import classNames from 'classnames';

interface ISearchTipProps {
  tip: IFullTipSchema;
  isTipsDisabled?: boolean;
  onClick: (tip: IFullTipSchema) => void;
}

export const SearchTip: React.FC<ISearchTipProps> = ({ tip, onClick, isTipsDisabled }) => {
  return (
    <div className={classNames(styles['tip'], isTipsDisabled && styles['disabled'])} onClick={() => onClick(tip)}>
      <UIText1 color={isTipsDisabled ? 'text-primary-disabled' : 'primary_100'}>{tip.text}</UIText1>
    </div>
  );
};
